import React from "react";
import "./DescriptionBox.css";

export const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-navbox">Description</div>
        <div className="descriptionbox-navbox fade">Reviews (122)</div> </div>
        <div className="descriptionbox-description">
          <p>
            Welcome to our online store, where fashion meets comfort and style
            meets affordability. Explore our collection of trendy dresses, made
            from lightweight, super cloth material that's perfect for any
            occasion. Whether you're looking for a casual day dress or a
            glamorous evening gown, we have something for every taste and
            budget. Shop now and discover the perfect dress to elevate your
            wardrobe!
          </p>
          <p>
            Discover stylish dresses for every occasion at our online store.
            Made from lightweight, super cloth material, our dresses offer both
            comfort and style. Browse our collection today and find your new
            favorite outfit!
          </p>
       
      </div>
    </div>
  );
};
